export default "__VITE_ASSET__BKpH6Lcc__"